// src/components/LabelConIcono.jsx
import React from 'react';
import { Label } from 'reactstrap';

const LabelConIcono = ({
  TextoLabel,
  IconoLabel,
  JerarqLabel,
  onClick,
  esClickable,
  tagTexto = 'span',
  textStyle = {},
  labelStyle = {},
}) => {
  // Estilos básicos
  const cursorStyle = esClickable ? 'pointer' : 'default';
  const baseLabelStyle = {
    display: 'flex',
    alignItems: 'center',
    cursor: cursorStyle,
    padding: '5px',
    ...labelStyle,
  };

  // Genera estilo según la jerarquía (igual que antes)
  let textoEstilo = {};
  switch (JerarqLabel) {
    case 'principal':
      textoEstilo = { fontWeight: 'bold' };
      break;
    case 'secundario':
      textoEstilo = { fontStyle: 'italic' };
      break;
    // …otros casos
    default:
      break;
  }
  textoEstilo = { ...textoEstilo, ...textStyle };

  // Tag dinámico
  const Tag = tagTexto;

  return (
    <Label style={baseLabelStyle} onClick={esClickable ? onClick : undefined}>
      {IconoLabel && (
        // Si IconoLabel es un elemento React, lo renderizamos directamente.
        React.isValidElement(IconoLabel) ? (
          <span style={{ display: 'flex', marginRight: '8px' }}>
            {IconoLabel}
          </span>
        ) : (
          // En otro caso, asumimos string y lo ponemos en <img>
          <img
            src={IconoLabel}
            alt=""
            style={{ height: '25px', marginRight: '8px' }}
          />
        )
      )}
      <Tag style={textoEstilo}>{TextoLabel}</Tag>
    </Label>
  );
};

export default LabelConIcono;
